// schema
import * as ISchema from "@schema";

import { requestSubscription } from "react-relay";
import { Environment } from "relay-runtime";
import { subscription } from "./UpdateEventInNearbyWeekChanges.gql";
import { logger } from "@util/logger.util";

export function updateEventInNearbyWeekChangesSubscription(
  environment: Environment,
  input: ISchema.IUpdateEventInNearbyWeekChangeInput,
  changeHandler: (change: ISchema.IEventInNearbyWeekChange) => any,
) {
  if (!(environment instanceof Environment)) {
    // don't proceed if it's not a modern environment
    return;
  }

  const variables = {
    input,
  };

  return requestSubscription(environment, {
    subscription,
    variables,
    // optional but recommended:
    onCompleted: () =>
      logger.debug("Subscription request for UpdateEventInNearbyWeekChanges complete"),
    onError: (error) =>
      logger.error("Subscription request for UpdateEventInNearbyWeekChanges failed", error),
    updater: (store) => {
      const rootField = store.getRootField("updateEventInNearbyWeekChanges");

      if (!rootField) {
        return;
      }

      const calendarId = rootField.getValue("calendarId") as string;
      const currentMillis = rootField.getValue("currentMillis") as number;
      const affectedWeeks = rootField.getValue("affectedWeeks") as string[];

      if (!calendarId || !currentMillis || !affectedWeeks) {
        return;
      }

      changeHandler({
        calendarId,
        currentMillis,
        affectedWeeks,
        __typename: "EventInNearbyWeekChange",
      });
    },
  });
}
